document.addEventListener('octane.quiz.addToCart', function (e) {
    // your code for successfully added items
    console.log(e.detail,"addto cart"); // example: {items: [{id: '12345', quantity: 1}]}
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    const mainId = e.detail.items[0].id;
    let items = e.detail.items;
    let formData = {
      items: items,
      sections: cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    };
    fetch(`${routes.cart_add_url}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: mainId,
            errors: response.description,
            message: response.message,
          });

        } else if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form",
          productVariantId: mainId,
        });
        cart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (cart && cart.classList.contains("is-empty"))
          cart.classList.remove("is-empty");
        
      });
}, false);
document.addEventListener('octane.quiz.viewCart', function (e) {
    // your code for when the button to view the cart is clicked
    console.log(e.detail,"view vart");
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
      cart.open();
}, false);

document.addEventListener('gesturestart', function (e) {
    e.preventDefault(); // Prevent default zoom behavior
});
(function() {
    // Get the current URL
    var currentUrl = window.location.href;

    // Create a regular expression to match the pattern "/collections/types"
    var pattern = /\/collections\/types/;
   var pattern2 = /\/collections/;

    // Check if the URL matches the pattern
    if (pattern.test(currentUrl)) {
        // Extract the `constraint` parameter from the URL
        var urlParams = new URLSearchParams(window.location.search);
        var constraint = urlParams.get('constraint');

        // Construct the new URL
        var newUrl = 'https://www.ajjaya.com/collections/all/' + constraint;

        // Redirect to the new URL
        window.location.href = newUrl;
    }
   if (pattern2.test(currentUrl)) {
     var urlParams = new URLSearchParams(window.location.search);
     var page = urlParams.get('page');

     if(page){
       if(document.querySelectorAll(".collection.collection--empty.page-width").length > 0){
          let url = new URL(window.location.href);
          // Remove the 'page' query parameter
          url.searchParams.delete('page');
          // Redirect to the updated URL without the 'page' parameter
          window.location.href = url.href;
       }
     }
     
   }
})();
function waitForElement(selector, trigger, delayInterval, delayTimeout) {
  var interval = setInterval(function () {
    if (
      document &&
      document.querySelector(selector) &&
      document.querySelectorAll(selector).length > 0
    ) {
      clearInterval(interval);
      trigger();
    }
  }, delayInterval);
  setTimeout(function () {
    clearInterval(interval);
  }, delayTimeout);
}

const loadInfinateLoader = () => {
   var endlessScroll = new Ajaxinate({
    container: '#product-grid',
    pagination: '#AjaxinatePagination'
  });
}
setTimeout(function() {
   waitForElement("body.product  .jdgm-rev__body", function () {
       $(".jdgm-rev__body").each(function(){
           if($(this).text() == 'This review has no content.'){
             $(this).hide();
           }
       });
    }, 50, 15000);
  const chatWidgetInterval = setInterval(() =>{
    if(document.querySelectorAll("#shopify-chat iframe").length > 0){
      document.querySelector("#shopify-chat iframe").style.zIndex="1";
      clearInterval(chatWidgetInterval);
    }  
  },500);
  const chatWidgetInterval2 = setInterval(() =>{
    if(document.querySelectorAll("#shopify-chat inbox-online-store-chat").length > 0){
      document.querySelector("#shopify-chat inbox-online-store-chat").style.zIndex="1";
      clearInterval(chatWidgetInterval2);
    }  
  },500);
  if(document.querySelectorAll("#ProductGridContainer").length > 0){
    loadInfinateLoader();
  }

  const imageSlider = new Swiper(".section-image-slider .swiper", {
    // Optional parameters
    loop: true,

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    // And if we need scrollbar
  });
}, 2000);
theme.Shopify = {
  formatMoney: function formatMoney(t, r) {
    function e(t, r) {
      return void 0 === t ? r : t;
    }
    function a(t, r, a, o) {
      if (
        ((r = e(r, 2)), (a = e(a, ",")), (o = e(o, ".")), isNaN(t) || null == t)
      )
        return 0;
      t = (t / 100).toFixed(r);
      var n = t.split(".");
      return (
        n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) +
        (n[1] ? o + n[1] : "")
      );
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var o = "",
      n = /\{\{\s*(\w+)\s*\}\}/,
      i = r || this.money_format;
    switch (i.match(n)[1]) {
      case "amount":
        o = a(t, 2);
        break;
      case "amount_no_decimals":
        o = a(t, 0);
        break;
      case "amount_with_comma_separator":
        o = a(t, 2, ".", ",");
        break;
      case "amount_with_space_separator":
        o = a(t, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        o = a(t, 2, " ", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        o = a(t, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        o = a(t, 0, " ", "");
        break;
      case "amount_with_apostrophe_separator":
        o = a(t, 2, "'", ".");
        break;
      case "amount_with_decimal_separator":
        o = a(t, 2, ".", ".");
    }
    return i.replace(n, o);
  },
};
const loadProgressbar = async function () {
  if (document.querySelectorAll(".freeshipping-wrapper").length > 0) {
    let rate = +Shopify.currency.rate;
    const mainElement = document.querySelector(".freeshipping-wrapper");
    const amount = +mainElement.dataset.threshold;
    const total = +mainElement.dataset.total;
    const country = mainElement.dataset.country;
    const amountInCent = amount * 100;
    const convertedDefaultAmount = Math.round(amountInCent * rate);

    const shippingAmount = convertedDefaultAmount - total;
    mainElement.querySelector(
      ".shipping-text-wrapper .custom-amount"
    ).innerHTML = theme.Shopify.formatMoney(shippingAmount, theme.money_format);
    if (convertedDefaultAmount <= total) {
      mainElement.querySelector(".free-text-wrapper").style.display = "block";
      mainElement.querySelector(".shipping-text-wrapper").style.display =
        "none";
    } else {
      mainElement.querySelector(".free-text-wrapper").style.display = "none";
      mainElement.querySelector(".shipping-text-wrapper").style.display =
        "block";
    }
    let progress = ((total / convertedDefaultAmount) * 100).toFixed(0);
    if (progress > 100) {
      progress = 100;
    }
    mainElement.querySelector(".progress").style.width = `${progress}%`;
  }
};

function recommendationAddProductToCart(evt) {
  const cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");
  const submitButton = evt.currentTarget;
  submitButton.setAttribute("aria-disabled", true);
  submitButton.classList.add("loading");
  submitButton
    .querySelector(".loading__spinner")
    .classList.remove("hidden");
  const mainId = submitButton.dataset.vid;
  let items = [
    {
      id: mainId,
      quantity: 1,
    },
  ];
  let formData = {
    items: items,
    sections: cart.getSectionsToRender().map((section) => section.id),
    sections_url: window.location.pathname,
  };
  fetch(`${routes.cart_add_url}.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: "product-form",
          productVariantId: mainId,
          errors: response.description,
          message: response.message,
        });

        const soldOutMessage = submitButton.querySelector(".sold-out-message");
        if (!soldOutMessage) return;
        submitButton.setAttribute("aria-disabled", true);
        submitButton.querySelector("span").classList.add("hidden");
        soldOutMessage.classList.remove("hidden");
      } else if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "product-form",
        productVariantId: mainId,
      });
      cart.renderContents(response);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      submitButton.classList.remove("loading");
      if (cart && cart.classList.contains("is-empty"))
        cart.classList.remove("is-empty");
      submitButton.removeAttribute("aria-disabled");
      submitButton
        .querySelector(".loading__spinner")
        .classList.add("hidden");
    });
}

var reinitCustomAddtoCartButtons = function () {
  document.querySelectorAll(".recommandaion-product-add").forEach((el) => {
    el.addEventListener("click", recommendationAddProductToCart);
  });
};
var loadProductRecommendationsIntoSectionCart = function () {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(
    ".product-recommendations-cart"
  );
  if (productRecommendationsSection === null) {
    return;
  }

  // Read vars from attributes
  var productId = productRecommendationsSection.dataset.productId;
  var limit = productRecommendationsSection.dataset.limit;
  var adv_ratio = productRecommendationsSection.dataset.adv_ratio;
  var prod_thumb_img_ratio =
    productRecommendationsSection.dataset.prod_thumb_img_ratio;

  // Build request URL
  var requestUrl =
    productRecommendationsSection.dataset.url +
    "?section_id=product-recommendation-cart&limit=" +
    limit +
    "&product_id=" +
    productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function () {
    if (request.status >= 200 && request.status < 300) {
      /*var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = $(request.response)(".product-recommendations-cart").innerHTML;*/

      productRecommendationsSection.innerHTML = new DOMParser()
        .parseFromString(request.response, "text/html")
        .querySelector(".product-recommendations-cart").innerHTML;
      reinitCustomAddtoCartButtons();
      // set correct image shape
      const reslider = new Swiper(".recommendations-slider .swiper-container", {
        // Optional parameters
        direction: "horizontal",
        spaceBetween: 20,
        slidesPerView: 1,
        roundLengths: true,
        loop: true,
        arrow: true,
        breakpoints: {
          1199: {
            slidesPerView:4,
          },
          991: {
            slidesPerView: 4,
          },
          800: {
            slidesPerView: 4,
            arrow: false,
          },
          500: {
            slidesPerView: 3,
          },
          320: {
            slidesPerView: 2,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }
  };
  request.send();
};

// product page ugc video slider
function waitForSwiper(trigger) {
  var interval = setInterval(function () {
    if (typeof Swiper != "undefined") {
      clearInterval(interval);
      trigger();
    }
  }, 50);
  setTimeout(function () {
    clearInterval(interval);
  }, 15000);
}

function addScript() {
  var swiperScript = document.createElement("script");
  swiperScript.src =
    "https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.0.7/js/swiper.min.js";
  document.getElementsByTagName("head")[0].appendChild(swiperScript);
}


document.addEventListener('StartAsyncLoading',function(event){
  
  if (typeof Swiper == "undefined") {
    addScript();
  }
  
  waitForSwiper(function () {
    var egswiperTiktok = new Swiper(".eg-video-section .swiper-container", {
      // Optional parameters
      direction: "horizontal",
      spaceBetween: 20,
      slidesPerView: 4,
      roundLengths: true,
      loop: true,
      arrow: true,
      breakpoints: {
        1800: {
          slidesPerView: 6,
          arrow: false,
          navigation: false,
        },
        1199: {
          slidesPerView: 4,
        },
        991: {
          slidesPerView: 3.3,
        },
        800: {
          slidesPerView: 2.6,
          arrow: false,
        },
        500: {
          slidesPerView: 1.2,
        },
        320: {
          slidesPerView: 1.2,
        },
      },
      pagination: {
        el: ".eg-video-section-inr .slider__pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".eg-video-section .swiper-button-next",
        prevEl: ".eg-video-section .swiper-button-prev",
      },
    });
   var productSwiperSlider = new Swiper(".product-swiper-slider", {
    centeredSlides: false,
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
        slidesPerGroup: 1,
      },
      991: {
        slidesPerView: 4,
      }
     }
    });

    var etsyswiperTiktok = new Swiper(".etsy-reviews-swiper .swiper-container", {
      // Optional parameters
      direction: "horizontal",
      spaceBetween: 20,
      slidesPerView: 3,
      loop: true,
      arrow: true,
      mousewheel: {
      forceToAxis: true, // Enable mousewheel control
      },
      breakpoints: {
        1199: {
          slidesPerView: 4,
        },
        991: {
          slidesPerView: 2.5,
        },
        800: {
          slidesPerView: 2.5,
          arrow: false,
        },
        500: {
          slidesPerView: 2,
        },
        320: {
          slidesPerView: 1,
        },
      },
      pagination: {
        el: ".etsy-reviews-swiper .slider__pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".etsy-reviews-swiper .swiper-button-next",
        prevEl: ".etsy-reviews-swiper .swiper-button-prev",
      },
    });

});

});


var slider2 = new Swiper ('.product .product-gallery-slider', {
    slidesPerView: 1,
    centeredSlides: true,
    autoHeight: true,
    loop: false,
    loopedSlides: 6, 
    zoom: true,
    navigation: {
        nextEl: '.product .swiper-button-next',
        prevEl: '.product .swiper-button-prev',
    },
    scrollbar: {
        el: '.product .swiper-scrollbar',
        draggable: true,
        dragSize: 150
      }
});

var thumbs2 = new Swiper ('.product .gallery-thumbs', {
    slidesPerView: '3',
    spaceBetween: 10,
    centeredSlides: true,
    loop: false,
    slideToClickedSlide: true,
});
slider2.controller.control = thumbs2;
thumbs2.controller.control = slider2;



if(document.querySelector(".facets__wrapper")){
   let itemsclass = document.querySelector(".facets__wrapper").querySelectorAll("details");
 itemsclass.forEach(item => {
     itemsclass.forEach(item => {item.removeAttribute('open')});
   item.addEventListener("click", () => {
     setTimeout(() => {
         item.setAttribute("open", "");
       }, 100);
    });
  });
 }
jQuery(window).on("load",function(){
  var $ = window.jQuery;
    setTimeout(function(){
       $(document).click(function(evt){
        if (!$(evt.target).closest('.localization-form').length) {
           $(".disclosure__button").attr("aria-expanded","false");
          $(".disclosure__list-wrapper").attr("hidden","true");
        }
        console.log(evt,"custom click on outside on timer");
      });
    },2000);
});
 var boxBarTexts = [];
function updateBoxBartexts(){
  boxBarTexts = [];
  $(".wrapper-box").each(function() {
  $(this).children(".box.desktop").each(function() {
    boxBarTexts.push(this.innerHTML);
  });
  });
}
jQuery(document).ready(function($){
 
  $("svg.modal__toggle-open.icon.icon-search").click(function(){
    
     setTimeout(function(){
       $('input.search__input.field__input').focus();
    },1000);
  });
  
  $('#read-more').click(function (){
      $('#product-description').show();
      $('#truncated-product-description').hide();
    });
   $('#read-less').click(function (){
      $('#product-description').hide();
      $('#truncated-product-description').show();
    });
    if(document.querySelectorAll('.ajj_quanity_reviews span.reviews').length > 0) {
     const reviewInterval = setInterval(()=> {
       if(document.querySelectorAll(".es-header-total-reviews-value").length > 0) {
           document.querySelector('.ajj_quanity_reviews span.reviews').textContent = document.querySelector(".es-header-total-reviews-value").textContent;
         clearInterval(reviewInterval);
       }
    
    },1000);
  }
    // product select box
  $(document).on("click", ".product-option-select", function(){
    $(this).siblings('.variant-option-dropdown').toggleClass('option-hide');
  });
  $(document).on("click", ".product-option", function(){
    var option_value = $(this).find('label').text();
    $(this).parent().siblings('.product-option-select').children('.product-option-select-text').text(option_value);
    $(this).parent().removeClass('option-hide');
  });
  
  // filter sort by 
  var filterlabel = $('input[checked]').siblings('label').text();
  $('.select-option-valu-text').text(filterlabel);
  
  $(document).on("click", ".select-option-valu", function(){
     $('.facet-filters__field .select').toggleClass("filter-hide");
  });
  
  $(document).on("click", "ul#SortBy li", function(){
    setTimeout(() => {
      var filterurl = window.location.href;
      console.log(filterurl)
      window.location.reload(filterurl);
    }, "1000");
  })

  // Header search
  $(document).on("click", ".header__search summary.header__icon.header__icon--search.header__icon--summary.link.focus-inset.modal__toggle", function(){
    setTimeout(() => {
      $(".header__search details").toggleClass('main').attr("open", true);
    }, "200");
  });
  $(document).on("click", "button.search-modal__close-button.modal__close-button.link.link--text.focus-inset", function(){
    $(".header__search details").removeClass('main').removeAttr("open", true);
  });
  
  // menu drawer
  $(document).on("click", "#Details-menu-drawer-container", function(){
      $('#Details-menu-drawer-container summary').attr('aria-expanded', true);
  });
  $(document).click(function(evt){
    if (!$(evt.target).closest('.facets__wrapper details').length) {
       $(".facets__wrapper details").each(function(){
        $(this).removeClass("menu_hover-filter");
        $(this).removeAttr("open");
      });
    }
    console.log(evt,"custom click on outside");
  });
  $(document).on("click", ".facets__wrapper details", function(){
    $(".facets__wrapper details").each(function(){
      $(this).removeClass("menu_hover-filter");
      $(this).removeAttr("open");
    });
    $(this).toggleClass('menu_hover-filter');
     //$(this).siblings().removeClass('menu_hover-filter');
     const $that = $(this);
     if($that.attr("open")){
       $that.removeAttr('open');
     }else{
       $that.attr('open','');
     }
  });

  $(document).on("click", "summary.facets__summary", function(){
    $('.facet-filters.sorting.caption').toggleClass('hidde_filter');
  });

  $(document).on("click", ".filter-hide", function(){
    $('#FacetsWrapperDesktop.facets__wrapper').toggleClass('show-menu-filter');
  });

  $(document).on("click", ".menu-drawer__menu > li > details > summary", function(){
    setTimeout(() => {
      $(this).parent('details').toggleClass('hover_menu');
    }, 200);
  })
  
  $(document).on("click",'button.slider-button.slider-button--prev-custom',function(){
     $(`.thumbnail-list__item.slider__slide button[aria-current="true"]`).parent("li").prev("li").find("button").attr('aria-current', true);
     $(`.thumbnail-list__item.slider__slide button[aria-current="true"]`).parent("li").prev("li").find("button").click();
  });
  $(document).on("click",'button.slider-button.slider-button--next-custom',function(){
      $(`.thumbnail-list__item.slider__slide button[aria-current="true"]`).parent("li").next("li").find("button").click();
      // $(`.thumbnail-list__item.slider__slide button[aria-current="true"]`).parent("li").next("li").find("button").attr('aria-current', true);
  });
  
  $(document).on("click",'button.quick-add__submit.button',function(){
    setTimeout(() => {
      $('button.slider-button.slider-button--prev-custom').removeAttr('disabled', 'disabled');
    }, 1000);
  });

  $(document).on("click", "summary.header__icon", function(){
    $('.menu-drawer__menu.has-submenu details').removeClass('menu-opening');
    $('.menu-drawer__navigation li details').removeClass('hover_menu');
  });

  $(document).on("click", ".blank-div-menu-drawer", function(){
    $('#Details-menu-drawer-container').removeClass('menu-opening');
    $('#Details-menu-drawer-container').removeAttr('open');
    $('#Details-menu-drawer-container details').removeAttr('open');
    $('body').removeClass('overflow-hidden-tablet');
    //$('.menu-drawer__menu.has-submenu details').removeClass('menu-opening');
    //$('.menu-drawer__navigation li details').removeClass('hover_menu');
  });
  
  // variant Image
  
  $('input.search__input.field__input').click(function(){
      $('body').addClass('overflow-class');
    console.log('ddd')
  });
  $(".search-overlay").click(function(){
    $('body').removeClass('overflow-class');
  });
  $('summary.header__icon.header__icon--menu').click(function(){
    $('body').removeClass('overflow-class');
  });
  if($(".box.desktop").length > 0){
   
    var frist_box = $(".box.desktop").html();
      $('#box-bar-text').html(frist_box);
      $('#box-bar-text-last').html(frist_box);
    updateBoxBartexts();
    var index = 0;
    setInterval(function() {
      document.getElementById('box-bar-text').innerHTML = boxBarTexts[index];
      document.getElementById('box-bar-text-last').innerHTML = boxBarTexts[index];
      index = (index + 1) % boxBarTexts.length;
    }, 5000);
  }
  function collapse(el) {
	$(el).parent().removeAttr('open');
	$(el).siblings(':not(summary)').removeAttr('style');
  }
  $(function(){
	//Set accessibility attributes
	$('summary').each(function(){
		$(this).attr('role', 'button');
		if ($(this).parent().is('[open]')) { $(this).attr('aria-expanded', 'true'); }
		else { $(this).attr('aria-expanded', 'false'); }
	});
	
	//Event handler
	$('summary').on('click', function(e){
		e.preventDefault();
		if ($(this).parent().is('[open]')) {
			$(this).attr('aria-expanded', 'false');
			$(this).siblings(':not(summary)').css('transform', 'scaleY(0)');
			window.setTimeout(collapse, 200, $(this));
		} else {
			$(this).parent().attr('open', '');
			$(this).attr('aria-expanded', 'true');
		}
	});
    var truncate = function (elem, limit, after) {
      if (!elem || !limit) return;
      var content = elem.textContent.trim();
      content = content.split(' ').slice(0, limit);
      content = content.join(' ') + (after ? after : '');
      elem.textContent = content;
    };
    
    var revp = document.querySelectorAll('a.jdgm-rev__prod-link');
    for (var i = 0; i < revp.length; i++) {
      var q = truncate(revp[i], 7, '');
    }
    
    $('.product-option-select').click(function(){
      setTimeout(() => {
          var buttonvalue = $('button.product-form__submit span').text();
        if(buttonvalue != 'Sold out'){
            $('button.product-form__submit').removeClass('sold-out');
        }
      }, 1000);
    });
  });
});
 $(document).on("click",".custom-filter-box ", function(){
   console.log("fff")
      $(".custom-filter-box").removeClass("active");
       $(this).addClass("active");
      $(".filter-items").find(".item-content-wrapper").removeClass('mt-0');
      if($(this).hasClass("first-class")){
          $(".filter-items").removeClass("hide").slideDown(); 
         
          $(".filter-items").first().find(".item-content-wrapper").addClass('mt-0').show();
          $(".filter-items").first().next(".filter-items").find(".item-content-wrapper").hide();
      }else{
         $(".filter-items").addClass("hide").slideUp(); 
         const dataId = $(this).data("id");
        $(".filter-items").first().find(".item-content-wrapper").hide();
        $(`.filter-items[id="${dataId}"]`).find(".item-content-wrapper").addClass('mt-0').show();
        $(`.filter-items[id="${dataId}"]`).removeClass("hide").slideDown(); 
      }
      window.dispatchEvent(new Event("resize"));
    }); 
  if( $(".filter-items").length > 0){
    $(".filter-items").first().next(".filter-items").find(".item-content-wrapper").hide();
  }

// faq section 
document.addEventListener("DOMContentLoaded", function() {
  subscribe(PUB_SUB_EVENTS.variantChange, (evt) => {
    console.log("variantChange",evt);
    if(evt?.data?.variant){
      if(document.querySelectorAll(".website-visitor").length > 0){
        document.querySelectorAll(".website-visitor").forEach((el) => {
          if(el.dataset.id == evt.data.variant.id){
            el.classList.remove("hidden");
          }else{
            el.classList.add("hidden");
          }
        });
      }
    }
    setTimeout(() => {
      const preOrderWidgets = document.querySelectorAll(".preorder-widget-wrapper");
      if(preOrderWidgets.length > 0){
        preOrderWidgets.forEach((el) => {
          if(el.dataset.id == evt.data.variant.id){
            el.classList.remove("hidden");
            if(document.querySelector(".product-form__submit span")){
              document.querySelector(".product-form__submit span").textContent = "PRE-ORDER";
            }
          }else{
            el.classList.add("hidden");
          }
        })
      }
    },1000);
  });
  
  if(document.querySelectorAll(".custom-footer-okendo-widget").length > 0){
    const okendoReviewBadgeInterval = setInterval(() => {
       if(document.querySelectorAll(".custom-footer-okendo-widget .oke-largeBadge-count").length > 0){
         document.querySelectorAll(".custom-review-count").forEach((el) => {
           el.textContent = document.querySelector(".custom-footer-okendo-widget .oke-largeBadge-count").textContent;
         })
         updateBoxBartexts();
         clearInterval(okendoReviewBadgeInterval);
       }
      
    },1000);
  }
  // Get all accordion headers
  const accordionHeaders = document.querySelectorAll('.menu-drawer__navigation .accordion__header');

  // Loop through each header and add event listeners
  accordionHeaders.forEach(header => {
    header.addEventListener('click', function() {
      const content = this.nextElementSibling; // The content associated with the header

      // Check if the content is already open
      if (content.style.display === 'block') {
        // If content is open, close it
        content.style.transform = 'scaleY(0)';
        content.style.opacity = '0';
        
        // After the animation, set display to none
        setTimeout(() => {
          content.style.display = 'none';
        }, 300); // Timeout matches transition duration

        this.classList.remove('active');
        this.querySelector('.plus-icon').classList.add('open');
      } else {
        // If content is closed, open it
        content.style.display = 'block';
        setTimeout(() => {
          content.style.transform = 'scaleY(1)';
          content.style.opacity = '1';
        }, 10); // Small delay to allow for display change

        this.classList.add('active');
        this.querySelector('.min-caret').classList.add('open');
      }
    });
  });
});
// end faq section 

const originalTitle = document.title;
let intervalID = null;
function handleVisibilityChange() {
  if(window.ABTEST.ab08 === 'v1' || (document.body.classList.contains("hw-abt-8-1") && window.ABTEST.ab08 === 'test')){
  document.hidden
    ? (clearInterval(intervalID),
      (intervalID = setInterval(() => {
        document.title === originalTitle
          ? (document.title = window.pageTabTitleMessage)
          : (document.title = originalTitle);
      }, 10000)))
    : (clearInterval(intervalID), (document.title = originalTitle));

  }
}
document.addEventListener("visibilitychange", handleVisibilityChange);
document.addEventListener('DOMContentLoaded', () => {
  const togglers = document.querySelectorAll('.custom-pdp-accordion [data-toggle]');
  if(togglers.length > 0){
    togglers.forEach((btn) => {
      btn.addEventListener('click', (e) => {
         const selector = e.currentTarget.dataset.toggle
         const block = document.querySelector(`${selector}`);
        if (e.currentTarget.classList.contains('active')) {
          //block.style.height = '';
          block.style.maxHeight = '';
        } else {
         // block.style.height = (block.scrollHeight+50) + 'px';
          block.style.maxHeight = (block.scrollHeight) + 'px';
        }
          
         e.currentTarget.classList.toggle('active')
      });
    });
  }
  
});

// Klaviyo Country Code Auto-Detection - Based on Your Actual Code
// This works with your specific Klaviyo phone component implementation

/*(function() {
  'use strict';

  // Global flag to prevent multiple executions
  window.klaviyoCountrySet = window.klaviyoCountrySet || false;

  // Set country code in your Klaviyo Redux store
  function setKlaviyoCountryCode() {
    // Check if already executed
    if (window.klaviyoCountrySet) {
      console.log('Country code already set, skipping...');
      return true;
    }

    // Method 1: Direct Redux store manipulation
    // Look for the store in window object
    const possibleStores = [
      window.__REDUX_STORE__,
      window.store,
      window._store
    ];

    for (const store of possibleStores) {
      if (store && store.dispatch) {
        try {
          // Based on your code, the action should update component data
          store.dispatch({
            type: 'forms/setComponentData', // or similar action type
            payload: {
              componentId: getPhoneComponentId(),
              data: {
                selectedCountryCode: window.currentCountryCode
              }
            }
          });
          console.log(`Country code set via Redux: ${window.currentCountryCode}`);
          window.klaviyoCountrySet = true; // Mark as executed
          return true;
        } catch (e) {
          console.warn('Redux method failed:', e);
        }
      }
    }

    // Method 2: Simulate user interaction with your dropdown
    return simulateCountrySelection();
  }

  // Get phone component ID from your rendered form
  function getPhoneComponentId() {
    // Look for the phone input with your specific ID pattern
    const phoneInput = document.querySelector('input[type="tel"][id*="_"]');
    if (phoneInput && phoneInput.id) {
      // Extract component ID from the pattern: fieldId_componentId
      const parts = phoneInput.id.split('_');
      return parts[parts.length - 1];
    }
    return null;
  }

  // Simulate clicking your country dropdown and selecting country
  function simulateCountrySelection() {
    // Check if already executed
    if (window.klaviyoCountrySet) {
      console.log('Country selection already executed, skipping...');
      return true;
    }

    // Find your country button based on the code structure
    const countryButton = document.querySelector('button[role="combobox"][aria-label="Search Countries"]');
    
    if (!countryButton) {
      console.warn('Country dropdown button not found');
      return false;
    }

    const mainElementDiv = countryButton.closest(`div[data-testid="form-component"]`);
    if(mainElementDiv){
      mainElementDiv.classList.add("custom-div-hide");
    }

    // Click to open dropdown
    countryButton.click();
    
    setTimeout(() => {
      // Look for country options in the opened dropdown
      const countryOptions = document.querySelectorAll('[role="option"]');
      
      for (const option of countryOptions) {
        // Check if this option matches our country code
        const optionText = option.textContent || '';
        
        // Look for country code in the option text (e.g., "+44" for GB)
        const callingCode = `+${getCallingCodeForCountry()}`;
        
        if (optionText.includes(callingCode) && optionText.toLowerCase().includes(getCountryName().toLowerCase())) {
          
          option.click();
          console.log(`Country ${window.currentCountryCode} selected via UI interaction`);
          window.klaviyoCountrySet = true; // Mark as executed
          setTimeout(()=>{
            if(mainElementDiv){
              mainElementDiv.classList.remove("custom-div-hide");
            }
          },1000);
          return true;
        }
      }
      
      // Close dropdown if country not found
      console.warn(`Country ${window.currentCountryCode} not found in options`);
        //if(mainElementDiv){
        //  mainElementDiv.classList.remove("custom-div-hide");
        }//
      return false;
      
    }, 300);
  }

  // Get calling code for country (based on your COUNTRY_CODES_WITH_CALLING_CODE data)
  function getCallingCodeForCountry() {
    const countryCodes = {
      'US': '1', 'CA': '1', 'GB': '44', 'AU': '61', 'DE': '49',
      'FR': '33', 'IT': '39', 'ES': '34', 'NL': '31', 'SE': '46',
      'NO': '47', 'DK': '45', 'FI': '358', 'IE': '353', 'BE': '32',
      'AT': '43', 'CH': '41', 'PT': '351', 'GR': '30', 'PL': '48',
      'CZ': '420', 'HU': '36', 'RO': '40', 'BG': '359', 'HR': '385',
      'IN': '91', 'CN': '86', 'JP': '81', 'KR': '82', 'SG': '65',
      'BR': '55', 'AR': '54', 'MX': '52', 'RU': '7', 'ZA': '27'
    };
    return countryCodes[window.currentCountryCode] || '1';
  }

  // Get country name for matching
  function getCountryName() {
    return window.currentCountryname;
  }

  // Wait for your specific Klaviyo component to load
  function waitForKlaviyoPhone(callback, maxAttempts = 30) {
    let attempts = 0;
    
    const checkForComponent = () => {
      attempts++;
      
      // Skip if already executed
      if (window.klaviyoCountrySet) {
        console.log('Country already set, stopping component search');
        return;
      }
      
      // Look for your specific phone input pattern
      const phoneInput = document.querySelector('input[data-testid="phoneNumberInput"]');
      const countryButton = document.querySelector('button[aria-label="Search Countries"]');
      
      if ((phoneInput || countryButton) && attempts < maxAttempts) {
        console.log('Klaviyo phone component detected');
        callback();
      } else if (attempts < maxAttempts) {
        setTimeout(checkForComponent, 200);
      } else {
        console.warn('Klaviyo phone component not found after maximum attempts');
      }
    };
    
    checkForComponent();
  }

  // Main initialization function
  async function initializeCountryDetection() {
    try {
      // Skip if already executed
      if (window.klaviyoCountrySet) {
        console.log('Country detection already completed, skipping...');
        return;
      }

      console.log(`Detected country: ${window.currentCountryCode}`);
      
      waitForKlaviyoPhone(() => {
        // Small delay to ensure component is fully rendered
        setTimeout(() => {
          const success = setKlaviyoCountryCode();
          if (!success && !window.klaviyoCountrySet) {
            console.warn('Failed to set country code, trying fallback method');
            // Try again with a longer delay
            setTimeout(() => {
              if (!window.klaviyoCountrySet) {
                setKlaviyoCountryCode();
              }
            }, 1000);
          }
        }, 100);
      });
      
    } catch (error) {
      console.error('Country detection initialization failed:', error);
    }
  }

  // Watch for dynamically loaded Klaviyo forms
  function observeKlaviyoForms() {
    const observer = new MutationObserver((mutations) => {
      // Skip if already executed
      if (window.klaviyoCountrySet) {
        return;
      }

      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            // Check if this node contains your phone component
            if (node.querySelector && (
                node.querySelector('input[data-testid="phoneNumberInput"]') ||
                node.querySelector('button[aria-label="Search Countries"]')
              )) {
              console.log('New Klaviyo phone component detected');
              setTimeout(initializeCountryDetection, 100);
              break;
            }
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Clean up observer after 30 seconds or when country is set
    const cleanup = () => {
      observer.disconnect();
      console.log('MutationObserver cleaned up');
    };

    setTimeout(cleanup, 30000);

    // Also cleanup when country is set
    const checkCleanup = setInterval(() => {
      if (window.klaviyoCountrySet) {
        cleanup();
        clearInterval(checkCleanup);
      }
    }, 1000);
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeCountryDetection();
      observeKlaviyoForms();
    });
  } else {
    initializeCountryDetection();
    observeKlaviyoForms();
  }

  // Expose manual control for testing (with reset option)
  window.setKlaviyoCountry = function(force = false) {
    if (force) {
      window.klaviyoCountrySet = false; // Reset flag if forced
    }
    console.log(`Manually setting Klaviyo country to: ${window.currentCountryCode}`);
    return setKlaviyoCountryCode();
  };

  // Expose reset function for testing
  window.resetKlaviyoCountryFlag = function() {
    window.klaviyoCountrySet = false;
    console.log('Klaviyo country flag reset');
  };

})();*/

// Alternative method: Hook into Klaviyo's component lifecycle
/*(function() {
  // Skip if already executed
  if (window.klaviyoCountrySet) {
    return;
  }

  // Override the component's useEffect to set country code when it mounts
  const originalUseEffect = window.React?.useEffect;
  
  if (originalUseEffect) {
    window.React.useEffect = function(effect, deps) {
      // Check if this is the phone component mounting
      if (deps && deps.length === 0) { // Empty dependency array indicates mount
        const wrappedEffect = function() {
          const result = effect();
          
          // Try to set country code after component mounts
          setTimeout(async () => {
            if (document.querySelector('input[data-testid="phoneNumberInput"]') && !window.klaviyoCountrySet) {
              window.setKlaviyoCountry?.();
            }
          }, 100);
          
          return result;
        };
        
        return originalUseEffect.call(this, wrappedEffect, deps);
      }
      
      return originalUseEffect.call(this, effect, deps);
    };
  }
})();*/